import Header from "../../Questions/component/Header";
import style from "../css/SubmitUserDetails.module.css";
import bg from "../../../icons/loginBg.png";
import bottle from "../../../icons/collectLoginIcon.png";
import contact from "../../../icons/contactIcon.png";
import phoneIcon from "../../../icons/phoneIcon.png";
import otp from "../../../icons/otp.svg";
import { ErrorHandling } from "../../../State";
import { useState, useEffect } from "react";
import UAParser from "ua-parser-js";
import { v4 as uuidv4 } from "uuid";
import {
  submitQuestions,
  sendOtpUtil,
  signInUtil,
  offerEvent,
  fetchIpAddress,
  updateFanduUser,
} from "../../../utils/api";
import male from "../../../icons/maleIcon.png";
import female from "../../../icons/femaleIcon.png";
import { useNavigate } from "react-router-dom";
import { SoftHeader } from "../../Questions/component/RandomQuestions";
import { ChevronUp } from "lucide-react";

function SubmitUserDetails({ onSubmit, isNavigate, isContest }) {
  const [isLoading, setLoading] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [otp, setOtp] = useState("");
  const [focusInput, setFocusInput] = useState(true);
  const [userSubmitId, setUserSubmitId] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [gender, setGender] = useState("");

  let mId = localStorage.getItem("mId") || "2026";
  let uuid = localStorage.getItem("uuid");
  let session_id = localStorage.getItem("session_id");

  const navigate = useNavigate();

  const [showToast, setShowToast] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowToast(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const generateUUIDUsingMachineId = (mId) => {
    try {
      const generatedUUID = uuidv4();

      return `${generatedUUID.substring(0, 24)}${(mId || "").substring(0, 12)}`;
    } catch (error) {
      ErrorHandling("Unable to initialize device session");
      return uuidv4();
    }
  };

  try {
    if (!uuid) {
      uuid = generateUUIDUsingMachineId(mId);
      localStorage.setItem("uuid", uuid);
    }
  } catch (error) {
    ErrorHandling("Unable to initialize application");
  }

  useEffect(() => {
    if (!isNavigate) avail2();
  }, []);

  const getIpAddress = async () => {
    try {
      const data = {
        device_id: uuid || "",
        session_id: session_id || "",
        user_id: localStorage.getItem("userId") || "",
        machine_id: mId || "",
      };

      const response = await fetchIpAddress(data);

      if (response?.ip_address) {
        setIpAddress(response.ip_address);
        localStorage.setItem("ip_address", response.ip_address);
      } else {
        ErrorHandling("Unable to fetch IP address");
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch IP address",
      );
    }
  };

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();
      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: session_id || "",
        user_id: localStorage.getItem("userId") || "",
        ip_address: ipAddress || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device information");
      return null;
    }
  };

  const avail2 = async () => {
    try {
      const eventMetaData = {
        Event_Name: "Fandu_SubmitQuiz_Page",
        Event_Sub_Name: "Quiz",
        Event_Type: "Page_Open",
        Event_Sub_Type: "SubmitQuiz_Page",
      };

      const requestData = offerRequestData(eventMetaData);

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Offer Event Error:", error);
    }
  };

  const avail = async (userSubmitId) => {
    try {
      const selectedAnswers = JSON.parse(
        localStorage.getItem("selectedAnswers"),
      );

      const eventMetaData = {
        Event_Name: "Fandu_Contest",
        Event_Sub_Name: "Quiz",
        Event_Type: "Click",
        Event_Sub_Type: "Submit_Quiz",
        Event_MetaData: {
          quiz_id: selectedAnswers?.quiz_id,
          total_questions: selectedAnswers?.responses?.length,
          user_id: userSubmitId,
        },
      };

      const requestData = offerRequestData(eventMetaData);

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Submit Quiz Event Error:", error);
    }
  };

  const avail3 = async (userSubmitId) => {
    try {
      const selectedAnswers = JSON.parse(
        localStorage.getItem("selectedAnswers"),
      );

      const eventMetaData = {
        Event_Name: "Fandu_Contest",
        Event_Sub_Name: "Quiz",
        Event_Type: "Click",
        Event_Sub_Type: "Register_Quiz",
        Event_MetaData: {
          quiz_id: selectedAnswers?.quiz_id,
          total_questions: selectedAnswers?.responses?.length,
          user_id: userSubmitId,
        },
      };

      const requestData = offerRequestData(eventMetaData);

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Register Quiz Event Error:", error);
    }
  };

  const handleChangeName = (e) => {
    try {
      setName(e.target.value);
      localStorage.setItem("userName", e.target.value);
    } catch (error) {
      console.log("Name Update Error:", error);
    }
  };

  const handleChangePhone = (e) => {
    try {
      const value = e.target.value;

      if (!isNaN(value)) {
        setPhone(value);
        localStorage.setItem("phone", value);
      }
    } catch (error) {
      console.log("Phone Update Error:", error);
    }
  };

  const submitQuestion = async () => {
    try {
      if (String(phone).length !== 10 || name.trim() === "") {
        return ErrorHandling(
          "Please enter your name and valid 10 digit mobile number",
        );
      }

      const selectedAnswers = JSON.parse(
        localStorage.getItem("selectedAnswers"),
      );

      if (!selectedAnswers) {
        return ErrorHandling("Quiz answers not found");
      }

      setLoading(true);

      const responses = selectedAnswers.responses;
      const quiz_id = isContest
        ? localStorage.getItem("rakhiQuizId")
        : localStorage.getItem("quizId");
      const mobile = phone;

      const finalPayload = {
        quiz_id,
        responses,
        name,
        mobile,
        gender,
      };

      const response = await submitQuestions(finalPayload);

      if (response?.success) {
        const data = response?.data || [];
        localStorage.setItem("token", response?.access_token);

        const correct = data.filter((item) => item.is_correct).length;

        const fanduUserId = response?.user_id;
        const userSubmitID = data?.[0]?.user_id;

        setUserSubmitId(userSubmitID);

        const userPayload = {
          platform_user_id: localStorage.getItem("userId"),
          fandu_id: fanduUserId,
        };

        if (!localStorage.getItem("fanduUserId")) {
          await updateFanduUser(userPayload);
        }

        localStorage.setItem("correctAnswers", correct);
        localStorage.setItem("fanduUserId", fanduUserId);
        localStorage.setItem("contestPlayed", true);

        const newPoints = Number(response.total_score || 0);

        localStorage.setItem("userFanduPoints", newPoints);
        // localStorage.setItem("userFanduPoints", response.total_score);

        await avail(userSubmitID);

        if (response?.is_otp_verified) {
          if (!isNavigate) navigate("/thanku");

          onSubmit?.();
        } else {
          await sentOTP();
        }
      } else if (!response?.success) {
        ErrorHandling(response?.message);
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to submit your responses",
      );
    } finally {
      setLoading(false);
    }
  };

  const sentOTP = async () => {
    try {
      if (String(phone).length !== 10) {
        return ErrorHandling("Please enter a valid 10 digit mobile number");
      }

      setShowOtp(true);
      setFocusInput(false);

      const response = await sendOtpUtil(phone);

      if (response?.success) {
        setTimeout(() => {
          const otpInput = document.getElementById("pswd");

          if (otpInput) {
            otpInput.focus();
          }
        }, 100);
      } else {
        ErrorHandling(response?.message || "Unable to send OTP");
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to send OTP",
      );
    }
  };

  const signIn = async () => {
    try {
      if (String(otp).length !== 4) {
        return ErrorHandling("Please enter a valid 4 digit OTP");
      }

      setLoading(true);

      const response = await signInUtil(phone, otp);

      await avail3(userSubmitId);

      if (response?.data?.access_token) {
        localStorage.setItem("token", response.data.access_token);

        if (!isNavigate) navigate("/thanku");

        //
        onSubmit?.();
      } else {
        ErrorHandling(response?.message || "OTP verification failed");
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to verify OTP",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChangeOtp = (e) => {
    try {
      if (!isNaN(e.target.value)) {
        setOtp(e.target.value);
      }
    } catch (error) {
      console.log("OTP Change Error:", error);
    }
  };

  const fanduPoints = localStorage.getItem("userFanduPoints") || "0";

  useEffect(() => {
    const storedIp = localStorage.getItem("ip_address");

    if (!storedIp || storedIp.trim() === "") {
      getIpAddress();
    } else {
      setIpAddress(storedIp);
    }
  }, []);

  return (
    <>
      {/* <motion.div
        drag="y"
        dragConstraints={{
          top: -120,
          bottom: 0,
        }}
        dragElastic={0.25}
        onDragEnd={(event, info) => {
          if (info.offset.y < -80) {
            onSkip();
          }
        }}
      > */}
      <div className={style.page}>
        <Header
          title="noArrow"
          path={`/vm/${mId}/`}
          fanduPoints={fanduPoints}
          avail={avail2}
        />
        <SoftHeader />
        <div className={style.viewport}>
          <div className={style.bannerSection}>
            <img src={bg} className={style.banner} alt="" />
          </div>
          <div className={style.bottomSection}>
            <div className={style.freeBottleContainer}>
              <img src={bottle} style={{ width: "90px", height: "60px" }} />
              <div className={style.freeBottleContent}>
                <p>Submit to Unlock</p>
                <p style={{ color: "#DF5276" }}>Free Punnyadhara Bottle</p>
              </div>
            </div>

            <div className={style.loginFormContainer}>
              <p className={style.submitText}>Submit Yours Details</p>
              <p className={style.submitSubText}>
                Secure your progress. <span>Save your points.</span>
              </p>
              <div className={style.detailsContainer}>
                <div className={style.nameText}>
                  <img
                    src={contact}
                    style={{ width: "10px" }}
                    className={style.icon}
                  />
                  {/* <p>Full Name</p> */}
                </div>
                <input
                  type="text"
                  required
                  value={name}
                  maxLength={30}
                  placeholder="Enter your Full Name.."
                  onChange={handleChangeName}
                  autoFocus={focusInput}
                />
                <div className={style.nameText}>
                  <img
                    src={phoneIcon}
                    style={{ width: "13px" }}
                    className={style.icon}
                  />
                  {/* <p>Mobile No.</p> */}
                </div>
                <input
                  type="text"
                  value={phone}
                  maxLength={10}
                  placeholder="Enter your Phone Number.."
                  onChange={handleChangePhone}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />

                <div className={style.genderContainer}>
                  <div className={style.genderField}>
                    <input
                      type="radio"
                      name="gender"
                      value="Male"
                      checked={gender === "Male"}
                      onChange={(e) => {
                        setGender(e.target.value);
                      }}
                    />
                    <img src={male} style={{ width: "25px" }} />
                    <span className={style.titleStyle}>Male</span>
                  </div>
                  <div className={style.genderField}>
                    <input
                      type="radio"
                      name="gender"
                      value="Female"
                      checked={gender === "Female"}
                      onChange={(e) => {
                        setGender(e.target.value);
                      }}
                    />
                    <img src={female} style={{ width: "25px" }} />
                    <span className={style.titleStyle}>Female</span>
                  </div>
                </div>

                <div className={!showOtp ? style.hide : style.show}>
                  <div className={style.nameText}>
                    <img
                      src={otp}
                      style={{ width: "10px" }}
                      className={style.icon}
                    />
                  </div>

                  <input
                    id={"pswd"}
                    maxLength={4}
                    value={otp}
                    placeholder="Enter your OTP"
                    onChange={handleChangeOtp}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    style={{ width: "100%" }}
                  />

                  <button onClick={signIn} className={style.saveBtn}>
                    Register
                  </button>
                </div>
                <button
                  onClick={submitQuestion}
                  className={
                    showOtp ? style.hide : `${style.show} ${style.saveBtn}`
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>

        {!isNavigate && (
          <p
            style={{
              color: "#3550DC",
              fontSize: "10px",
              textAlign: "center",
            }}
          >
            Swipe up to continue
            <span>
              <ChevronUp style={{ width: "12px", marginLeft: "5px" }} />
            </span>
          </p>
        )}
      </div>
      {/* </motion.div> */}
    </>
  );
}

export default SubmitUserDetails;
